export default __webpack_public_path__ + "static/media/index.00515a28.less";